import api from './api';

/**
 * 은행 목록 서비스
 * bank_accounts 테이블에서 활성화된 은행 목록을 조회
 */
const bankService = {
  /**
   * 활성화된 은행 목록 조회
   * @returns {Promise<Array<{value: string, label: string}>>} 은행 목록 (드롭다운용)
   */
  async getActiveBanks() {
    try {
      const response = await api.get('/settings/bank-accounts');
      const accounts = response.data || [];

      // 활성화된 은행만 필터링하고 드롭다운 형식으로 변환
      return accounts
        .filter(account => account.is_active === 1)
        .map(account => ({
          value: account.bank_name,
          label: account.bank_name
        }));
    } catch (error) {
      console.error('은행 목록 조회 실패:', error);
      return [];
    }
  },

  /**
   * 활성화된 은행명 배열 조회
   * @returns {Promise<string[]>} 은행명 배열
   */
  async getActiveBankNames() {
    try {
      const response = await api.get('/settings/bank-accounts');
      const accounts = response.data || [];

      return accounts
        .filter(account => account.is_active === 1)
        .map(account => account.bank_name);
    } catch (error) {
      console.error('은행 목록 조회 실패:', error);
      return [];
    }
  }
};

export default bankService;
